"use client";

import { useContext, useEffect, useMemo } from "react";
import Link from "next/link";

import { Button } from "@/components/common/Button";
import { NSContext } from "@/components/context/NSProvider";
import { ArchiveContext } from "@/components/context/ArchiveProvider";

import classNames from "classnames";

import styles from "./ShowArchiveSubMenu.module.css";

const ShowArchiveSubMenu = ({ type = "none" }) => {
  const { currentArchiveTab, setCurrentArchiveTab } =
    useContext(ArchiveContext);

  const { activeMenuItem, setActiveMenuItem } = useContext(NSContext);

  return (
    <div>
      <ul className={styles.typeContainer}>
        <li>
          <Link
            className={classNames(`sub-nav-item`, styles.archiveMenuItem, {
              [styles.active]:
                currentArchiveTab === "exhibition" || type === "exhibition",
            })}
            href={"/archive"}
            onClick={() => setCurrentArchiveTab("exhibition")}
            onKeyDown={() => setActiveMenuItem("show")}
          >
            EXHIBITION
          </Link>
        </li>
        <li>
          <Link
            className={classNames(`sub-nav-item`, styles.archiveMenuItem, {
              [styles.active]:
                currentArchiveTab === "event" || type === "event",
            })}
            href={"/archive"}
            onClick={() => setCurrentArchiveTab("event")}
            onKeyDown={() => setActiveMenuItem("show")}
          >
            EVENT
          </Link>
        </li>
        <li>
          <Link
            className={classNames(`sub-nav-item`, styles.archiveMenuItem, {
              [styles.active]: currentArchiveTab === "alt" || type === "alt",
            })}
            href={"/archive"}
            onClick={() => setCurrentArchiveTab("alt")}
            onKeyDown={() => setActiveMenuItem("show")}
          >
            ALT
          </Link>
        </li>
        <li>
          <Link
            className={classNames(`sub-nav-item`, styles.archiveMenuItem, {
              [styles.active]:
                currentArchiveTab === "library" || type === "library",
            })}
            href={"/archive"}
            onClick={() => setCurrentArchiveTab("library")}
            onKeyDown={() => setActiveMenuItem("show")}
          >
            LIBRARY
          </Link>
        </li>
      </ul>
    </div>
  );
};

export { ShowArchiveSubMenu };
